<template>
  <div class="management">
    <div class="content">
      <div class="title">
        <div>企业列表</div>
        <div class="tool">
          <el-input
            v-model.trim="searchValue"
            style="width:220px;margin-right:20px"
            size="small"
            placeholder="请输入"
            >
            <i slot="suffix" class="el-input__icon el-icon-search" @click="handleSearch(1)"></i>
          </el-input>
          <el-button size="small" type="primary" icon="el-icon-plus" @click="goRoute('')">添加</el-button>
        </div>
      </div>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="序号" type="index" width="80">
            <template slot-scope="scope">
              <span>{{(page-1)*10+scope.$index+1}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="企业名称" min-width="120"/>
          <el-table-column prop="managerId" label="用户ID" min-width="100"/>
          <el-table-column prop="managerName" label="管理员姓名" min-width="150"/>
          <el-table-column prop="managerPhone" label="管理员手机号" min-width="150"/>
          <el-table-column prop="address" label="所属地区" min-width="150"/>
          <el-table-column prop="code" label="客户ID" min-width="120"/>
          <el-table-column prop="distributorCode" label="经销商ID" min-width="100"/>
          <el-table-column prop="distributorName" label="经销商名称" min-width="180"/>
          <el-table-column prop="status" label="状态" min-width="100">
            <template slot-scope="scope">
              <span :class="[!scope.row.status?'greenStatus':'redStatus']">{{!scope.row.status?'启用':'禁用'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="180"/>
          <el-table-column label="操作" min-width="120" fixed="right" align="center">
            <template slot-scope="scope">
              <img 
                src="@/assets/images/common/edit.png" 
                style="margin-right:20px"
                @click="goRoute(scope.row)"
              />
              <img src="@/assets/images/common/del.png"  @click="comfirm(scope.row)"/>
            </template>
          </el-table-column>
      </el-table>
      <pagination :total="total" :page.sync="page" :size.sync="size"  @getTableData="handleSearch"/>
    </div>
  </div>
</template>

<script>
const pagination = () => import('@/components/pagination.vue')
import { isComfirm } from '@/utils/utils'
import { getEnterprise,deleteCustomer } from '@/api/management'
export default {
  name: "management",
  components:{
    pagination
  },
  data() {
    return {
      tableData:[],
      total:0,
      page:1,
      size:10,
      searchValue:'',
    };
  },
  watch:{
    size(){
      this.handleSearch(1)
    }
  },
  activated(){
    this.handleSearch()
  },
  methods:{
    //查询
    handleSearch(page){
      page ? this.page = page : this.page = 1;
      let params = {
        current:this.page,
        size:this.size,
        name:this.searchValue,
        address:this.searchValue,
        managerId:this.searchValue,
        managerName:this.searchValue,
        managerPhone:this.searchValue,
        distributorCode:this.searchValue,
        distributorName:this.searchValue,
        code:this.searchValue
      }
      getEnterprise(params).then(res=>{
        if(res.code==200){
          this.tableData = res.data.records
          this.total = res.data.total
        }else{
          this.$message.error(res.msg || '接口失败')
        }
      })
    },
    //二次确认
    comfirm(row){
      isComfirm(row,this.del)
    },
    //删除
    del(row){
      deleteCustomer(row.id).then(res=>{
        if(res.code==200){
          this.$message.success('删除成功')
          this.handleSearch(this.page)
        }else{
          this.$message.error(res.msg)
        }
      })
    },
    goRoute(row){
      this.$router.push({
        path:'management_edit',
        query:row
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/element-reset.scss';
.management{
  padding:10px 20px;
  position: relative;
  height: calc(100vh - 140px);
  text-align: left;
  color: #E8E8E8;
  .content{
    position: relative;
    background: #232323;
    min-height: calc(100vh - 250px);
    text-align: left;
    padding: 25px 35px 80px 35px;
    .title{
      font-size: 20px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
    }
    img{
      width: 22px;
      height: 22px;
      cursor: pointer;
    }
    .tool{
      width: 300px;
      display: flex;
      align-items: center;
    }
  }
  .greenStatus{
    &::before{
      content: '●';
      color: #2DEB79;
      margin-right: 5px;
      font-size: 20px;
    }
  }
 .redStatus{
    &::before{
      content: '●';
      color: #EB2D2D;
      margin-right: 5px;
      font-size: 20px;
    }
  }
}
</style>
